/*******************************************************************************
 * @license (c)Copyright Since 2018, SOFTBANK Corp. All rights reserved.
 *
 *    機能概要     :  内容確認画面の情報でセットするオブジェクト
 *                    setSelectDataファンクションからセットされる
 *    システム名　 :　iTunesCDD
 ******************************************************************************/
'use strict';

var selectData = {

    productVal: null,　　        // 商品の価格(バリアブル判定用)
    productPrice: null,         // 商品の価格
    chargePrice: null,          // チャージ金
    paymentPrice: null,         // 支払い金
    couponRate: null,           // Couponの比率
    couponCode: null,           // Couponのコード
    couponFlag: false,          // Coupon付け確認FLAG
    validCouponCodeFlag: true,  // Coupon有効確認Flag
    ribon_label_string: null,     // 画面表示用String
    variable_label_string: null,  // 画面表示用String
    fluctuationPrice: null,     // 割引金（画面表示用）
    giftFlag: false,            // Gift確認

    // 選択された商品情報の判定に使用するため格納
    setProductVal: function () {
        this.productVal = $('ul.item-list.select-radio > li > input:checked').val();
    },
    // calcPriceファンクションに使用するため格納
    setProductPrice: function () {
        if (this.productVal == "0") {
            var input = $('div.variable-form > input').val();
            return this.productPrice = input;
        } else {
            return this.productPrice = utility.removeComma(selectData.productVal);
        }
    },

    // Giftのチェックボックスが選択された場合セットする
    setGift: function () {
        if ($('input#option-gift').prop('checked')) {
            this.giftFlag = true;
            this.sendFromAddress = $("input#sendFromAddress").val();
            this.sendFromAddressForCheck = $("input#sendFromAddressForCheck").val();
            this.nameFrom = $("input#nameFrom").val();
            this.sendToAddress = $("input#sendToAddress").val();
            this.sendToAddressForCheck = $("input#sendToAddressForCheck").val();
            this.nameTo = $("input#nameTo").val();
            this.sendToMessage = $("textarea#sendToMessage").val();
        } else {
            this.giftFlag = false;
        }
    },

    // Couponチェック
    inquiryCouponData: function (ribon_label_string, variable_label_string) {
        this.couponRate = null;
        // Couponのチェックボックスが選択された場合
        if ($('ul.option-list > li > div > input#option-coupon').prop('checked')) {

            var couponCode = $('ul.option-list > li > div > div > input#couponCode').val(),
                postData = {
                    "coupon_code": couponCode
                };

            // Ajax通信でCoupon無効有効確認
            ajaxComponent.request('/v1/coupons', 'POST', 'application/json',
                    JSON.stringify(postData))
                .done(function (data, textStatus, xhr) {
                    // header から サーバー側のtokenをリフレッシュ
                    utility.tokeReflush(xhr);
                    // クーポン情報設定
                    var couponData = data;
                    selectData.validCouponCodeFlag = true;
                    selectData.couponFlag = true;
                    selectData.couponRate = couponData.coupon_rate;
                    selectData.ribon_label_string = "クーポン";
                    selectData.variable_label_string = (1 - couponData.coupon_rate).toFixed(2) * 100 + "%OFF";
                    selectData.couponCode = couponCode;
                })
                .fail(function (data) {
                    selectData.validCouponCodeFlag = false;
                });

        } else {
            // Couponのチェックボックスが選択されていない場合
            this.validCouponCodeFlag = true;
            this.couponFlag = false;
            this.ribon_label_string = ribon_label_string;
            this.variable_label_string = variable_label_string;
            // 内容確認の割引額の項目非表示
            delete this.fluctuationPrice;
        }
    },
    /** 
     * 支払い、チャージ金額計算処理
     * @param {int} fluctuationRate 増減量の割合
     */
    calcPrice: function (fluctuationRate) {
        var rate = fluctuationRate;
        var productPrice = parseInt(this.productPrice);
        var chargePrice = 0,
            paymentPrice = 0;

        if (rate == 1) { // 通常の場合
            chargePrice = productPrice;
            paymentPrice = (this.couponFlag) ?　Math.floor(chargePrice * this.couponRate) : productPrice;
        } else if (rate > 1) { // 増量の場合
            //　1.1 小数点切り上げ、JavaScriptでは小数点計算が正しくないので以下のように切る。
            rate = ((rate - 1).toFixed(2) * 100) / 100;
            chargePrice = Math.ceil((rate * productPrice) + productPrice);
            paymentPrice = productPrice;
            this.variable_label_string = utility.addComma(chargePrice - paymentPrice) + "円分増量中"

        } else { // 割引の場合
            // 小数点切り捨て
            chargePrice = this.productPrice;
            paymentPrice = Math.floor(rate * productPrice);
        }
        // 共通Comma処理呼び出し
        this.chargeAmount = utility.addComma(chargePrice);
        this.payAmount = utility.addComma(paymentPrice);

        // 割引金の表示
        if (productPrice > paymentPrice) {
            this.fluctuationPrice = "-" + utility.addComma(chargePrice - paymentPrice);
        }
    }
}